import { useContext, useEffect, useState } from "react";
import { PeFilterContext } from "../../Contexts/PeFilterContext";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

//toggle switch component
export default function Example({ customPathname, SwitchState, setSwitchState }) {
  const { refineSearchFilters } = useContext(PeFilterContext);

  useEffect(() => {
    const ope = refineSearchFilters[customPathname]?.operator == null ? true : refineSearchFilters[customPathname]?.operator === 1
    setSwitchState(ope)
  }, [customPathname, refineSearchFilters, setSwitchState])

  const buttonClassName = `flex items-center space-x-[6px] rounded py-[2px] px-[5px] text-[11px] cursor-pointer`;
  const buttonClassNameActive = `light text-[#FFFFFF] bg-[#BC8B20]`;
  const buttonClassNameInactive = `dark text-body-color`;

  return (
    <div className="py-1 pr-1">
      <div className="shadow-card relative inline-flex cursor-pointer select-none items-center justify-center rounded-md bg-white px-[5px] py-[2px]">
        <span
          onClick={() => setSwitchState(false)}
          className={`${buttonClassName} ${SwitchState === false ? `${buttonClassNameActive}` : `${buttonClassNameInactive}`}`}>
          AND
        </span>

        <span
          onClick={() => setSwitchState(true)}
          className={`${buttonClassName} ${SwitchState === true ? `${buttonClassNameActive}` : `${buttonClassNameInactive}`}`}>
          OR
        </span>
      </div>
    </div>
  );
}
